import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Toast notifications
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'layouts/pages/landing/formular-sesizare/customToast.css';

// Settings page components
import FormField from "layouts/pages/account/components/FormField";

import useAPI from "utils/useApi";

function ChangePassword() {
  const client = useAPI();
  
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const passwordRequirements = [
    "Un caracter special",
    "Minim 6 caractere",
    "Un număr (sunt recomandate 2)",
    "Schimbați parola des",
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validare
    if (!currentPassword || !newPassword || !newPasswordConfirm) {
      toast.error("Toate câmpurile sunt obligatorii");
      return;
    }

    if (newPassword !== newPasswordConfirm) {
      toast.error("Parolele noi nu coincid");
      return;
    }

    if (newPassword.length < 6) {
      toast.error("Parola nouă trebuie să aibă minim 6 caractere");
      return;
    }

    setLoading(true);
    try {
      await client.changePassword({
        current_password: currentPassword,
        new_password: newPassword,
        new_password_confirm: newPasswordConfirm,
      });
      toast.success("Parola a fost schimbată cu succes!");
      // Reset form
      setCurrentPassword("");
      setNewPassword("");
      setNewPasswordConfirm("");
    } catch (err) {
      const errorMessage = err.response?.data?.detail || 
                          err.response?.data?.message || 
                          err.response?.data?.current_password?.[0] ||
                          err.response?.data?.new_password?.[0] ||
                          "A apărut o eroare la schimbarea parolei";
      toast.error(errorMessage);
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const renderPasswordRequirements = passwordRequirements.map((item, key) => {
    const itemKey = `element-${key}`;

    return (
      <SoftBox key={itemKey} component="li" color="text" fontSize="1.25rem" lineHeight={1}>
        <SoftTypography variant="button" color="text" fontWeight="regular" verticalAlign="middle">
          {item}
        </SoftTypography>
      </SoftBox>
    );
  });

  return (
    <Card id="change-password">
      <ToastContainer 
        position="top-right" 
        autoClose={4000} 
        hideProgressBar={false} 
        newestOnTop 
        closeOnClick 
        rtl={false} 
        pauseOnFocusLoss 
        draggable 
        pauseOnHover
        theme="light"
      />
      <SoftBox p={3}>
        <SoftTypography variant="h5">Schimbă Parola</SoftTypography>
      </SoftBox>
      <SoftBox component="form" pb={3} px={3} onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormField
              label="parola curentă"
              placeholder="Parola Curentă"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              inputProps={{ type: "password", autoComplete: "current-password" }}
            />
          </Grid>
          <Grid item xs={12}>
            <FormField
              label="parola nouă"
              placeholder="Parola Nouă"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              inputProps={{ type: "password", autoComplete: "new-password" }}
            />
          </Grid>
          <Grid item xs={12}>
            <FormField
              label="confirmă parola nouă"
              placeholder="Confirmă Parola"
              value={newPasswordConfirm}
              onChange={(e) => setNewPasswordConfirm(e.target.value)}
              inputProps={{ type: "password", autoComplete: "new-password" }}
            />
          </Grid>
        </Grid>
        <SoftBox mt={6} mb={1}>
          <SoftTypography variant="h5">Cerințe pentru parolă</SoftTypography>
        </SoftBox>
        <SoftBox mb={1}>
          <SoftTypography variant="body2" color="text">
            Urmați acest ghid pentru o parolă puternică
          </SoftTypography>
        </SoftBox>
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="flex-end"
          flexWrap="wrap"
        >
          <SoftBox component="ul" m={0} pl={3.25} mb={{ xs: 8, sm: 0 }}>
            {renderPasswordRequirements}
          </SoftBox>
          <SoftBox ml="auto">
            <SoftButton 
              variant="gradient" 
              color="dark" 
              size="small"
              type="submit"
              disabled={loading}
            >
              {loading ? "Se procesează..." : "actualizează parola"}
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </Card>
  );
}

export default ChangePassword;
